import type {
  TimesheetStatus,
  TimesheetDueStatus,
  TimesheetSubmissionTiming,
} from '@catalyst-psa/shared';

import type { Badge } from '../../components/ui/Badge.js';

type BadgeTone = NonNullable<Parameters<typeof Badge>[0]['tone']>;

export const STATUS_LABELS: Record<TimesheetStatus, string> = {
  draft: 'Draft',
  submitted: 'Submitted',
  approved: 'Approved',
  rejected: 'Un-submitted',
};

export const STATUS_TONES: Record<TimesheetStatus, BadgeTone> = {
  draft: 'gray',
  submitted: 'blue',
  approved: 'green',
  rejected: 'red',
};

/** Live due state of a not-yet-submitted timesheet. */
export const DUE_STATUS_LABELS: Record<TimesheetDueStatus, string> = {
  not_due: 'Not due',
  due_this_week: 'Due this week',
  overdue: 'Overdue',
};

export const DUE_STATUS_TONES: Record<TimesheetDueStatus, BadgeTone> = {
  not_due: 'gray',
  due_this_week: 'amber',
  overdue: 'red',
};

/** Whether a submitted timesheet beat its deadline. */
export const SUBMISSION_TIMING_LABELS: Record<TimesheetSubmissionTiming, string> = {
  on_time: 'On time',
  past_due: 'Past due',
};

export const SUBMISSION_TIMING_TONES: Record<TimesheetSubmissionTiming, BadgeTone> = {
  on_time: 'green',
  past_due: 'red',
};
